<template>
  <div class="setting_content_sub" :id="idSetScroll">
    <div :id="'dispatch_job_heading_search_item_' + useType">
      <div class="setting_options_search d-flex justify-content-end">
        <button class="setting_btn_secondary setting_btn_medium" @click.prevent="refreshResourceList">
          {{ screenLabelsProperties.REFRESH_RESOURCE_BUTTON }}
        </button>
      </div>
      <div class="setting_options_search setting_options_search_customize">
        <p class="setting_options_search_label" v-if="isDispatch">
          {{ screenLabelsProperties.SEARCH_DISPATCH_JOB_LABEL }}
        </p>
        <p class="setting_options_search_label" v-else>
          {{ screenLabelsProperties.SEARCH_JOB_LABEL }}
        </p>
        <div class="setting_options_search_box">
          <input
              type="text"
              class="setting_form_text"
              :placeholder="screenLabelsProperties.SEARCH_PLACEHOLDER"
              v-model="computedProperty"
              v-on:keyup.enter="getJobResourceFields"
          />
          <button class="setting_btn_primary" v-on:click.prevent="getJobResourceFields">
            <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg">
              <g fill="none" fill-rule="evenodd">
                <circle stroke="#FFF" stroke-width="2" cx="6.5" cy="6.5" r="5.5"/>
                <path fill="#FFF" d="M10 11.98L11.98 10l4.242 4.243-1.98 1.98z"/>
              </g>
            </svg>
          </button>
        </div>
      </div>
    </div>
    <div class="setting_options_wrapper" :id="'item_resource_wrapper_' + useType">
      <div class="setting_options_category">
        <div v-for="(jobCategory, index) in jobCategories" :key="index">
          <template v-if="checkEmptyResourceCategory(jobCategory.name) && jobCategory.is_display === 1">
            <p class="setting_options_category_name jobs mt-3">
              {{ jobCategory.display_name }}
            </p>
            <draggable :group="{ name: 'item-job', put: false, pull: 'clone' }" :sort="false" :list="resourceFields">
              <div v-for="(resourceField, index) in resourceFields" :key="index">
                <div v-if="resourceField.isUsed && !resourceField.isUsed.includes(useType)" @mousedown="updateCanDragDrop()">
                  <div v-if="resourceField.property_category_name === jobCategory.name"
                       class="setting_options_category_item">
                    <svg class="setting_options_category_item_icon" width="10" height="12"
                         xmlns="http://www.w3.org/2000/svg">
                      <g fill="#aaa" fill-rule="evenodd">
                        <path d="M0 0h10v2H0zM0 5h10v2H0zM0 10h10v2H0z"/>
                      </g>
                    </svg>
                    <span class="setting_options_category_item_name" v-text="resourceField.display_name"></span>
                  </div>
                </div>
              </div>
            </draggable>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import screenLabelsProperties from "../../../../properties/entry_screen/screen_tab/screen-labels.json";

export default {
  name: "DragDropComponent",
  components: {
    draggable,
  },
  props: [
    "groupName",
    "resourceFields",
    "jobCategories",
    "property",
    "useType",
    "idSetScroll",
    "isDispatch"
  ],
  data() {
    return {
      screenLabelsProperties: screenLabelsProperties,
    };
  },
  computed: {
    computedProperty: {
      get() {
        return this.property;
      },
      set(val) {
        this.$emit("updatedProperty", val);
      },
    },
  },
  methods: {
    updateCanDragDrop(){
      this.$emit("updateCanDragDrop");
    },

    getJobResourceFields() {
      this.$emit("getJobResourceFields");
    },

    refreshResourceList() {
      this.$emit("refreshResourceList");
    },

    checkEmptyResourceCategory(name) {
      let count = 0;
      this.resourceFields.forEach(resource => {
        if (resource.isUsed && !resource.isUsed.includes(this.useType) && resource.property_category_name === name) {
          count++;
        }
      })

      return count !== 0;
    },
  },
};
</script>

<style lang="css" scoped>
.setting_options_search_customize {
  top: 42px !important;
}

.setting_options_search {
  height: 43px !important;
}

.setting_content_sub {
  padding-top: 85px !important;
}
.setting_options_wrapper{
  border-bottom: 1px solid #ddd;
}
</style>
